import styled from 'styled-components';

export const ClockCountdown = styled.div`
  display: flex;
  white-space: pre;
`;
